module.exports = __webpack_public_path__ + "static/media/image1.378e6bc0.jpeg";